<template>
  <router-link class="item" :class="{ active }" @click.native="hideSideBar()" :to="route">
    {{ label }}
  </router-link>
</template>

<script>

  export default {    
    
    name: "MenuItem",

    props: ["active", "route", "label"],

    methods: {
      
      hideSideBar() {
        $("#sidebar").sidebar("hide")
      },      
    },
  }

</script>